/**
 * VoipPurchaseFlow
 *
 * Small functional component that bridges the class-based CreatedVoipChat
 * with the hook-based PurchaseFlowWrapper.
 *
 * Renders a PurchaseFlowWrapper in 'additionalFunds' modal mode
 * for the paymentRequiredOnContinue state in VoIP chats.
 */

import React from 'react';
import { analyticsService } from '@common/analytics';
import { usePurchaseFlowRenderProps } from '@common/config/purchaseFlowRenderHelpers';
import PurchaseFlowWrapper from '../purchase_flow/containers/PurchaseFlowWrapper';
import classes from '../created_chat/classes.module.scss';

interface VoipPurchaseFlowProps {
  voipType: string;
  isContinue?: boolean;
  voipPurchaseOnBack: () => void;
  purchaseSuccess: () => void;
}

const VoipPurchaseFlow: React.FC<VoipPurchaseFlowProps> = ({
  voipType,
  isContinue,
  voipPurchaseOnBack,
  purchaseSuccess
}) => {
  const { renderIcon, renderText } = usePurchaseFlowRenderProps();

  return (
    <PurchaseFlowWrapper
      mode="additionalFunds"
      onComplete={ purchaseSuccess }
      onCancel={ voipPurchaseOnBack }
      onAnalyticsEvent={ (...args) => analyticsService.trackEvent(...args) }
      renderIcon={ renderIcon }
      renderText={ renderText }
      inModal
      popoverClassName="created-voip-chat-purchase-details-container"
      popoverContentClassName={ classes.purchasesModalContent }
      chatType={ voipType }
      isContinue={ isContinue }
      backArrowAction={ voipPurchaseOnBack }
    />
  );
};

export default VoipPurchaseFlow;
